import React from 'react';

import {Helmet, useNavigate} from 'views/module';

import ClientListScene from 'views/scenes/client/list/ClientList';
import CLIENT_SOURCES from 'views/scenes/client/client_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomClientList = () => {
  const clientReadFlag = useFlag(FLAGS.CLIENT_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (clientReadFlag.isLoading || clientReadFlag.isEnabled) return;

    navigate('/client', {replace: true});
  }, [clientReadFlag.isEnabled, clientReadFlag.isLoading, navigate]);

  if (clientReadFlag.isLoading || !clientReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Clients (Loom)</title>
      </Helmet>
      <ClientListScene
        clientSource={CLIENT_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomClientList;
